// @todo Re-Implement Group icons for Investigate Graph, commented out below.
export const getEntityTypeIcon = (type, isUnifiedAsset = false) => {
  switch (type) {
    case "asset":
    case "target":
    case "target-group":
    case "reticle":
      return "crosshair-simple";
    case "network.firewall":
      return "wall";
    case "cisco_mid":
    case "domain":
      return "globe";
    case "device":
      return "power";
    case "email_messageid":
      return "envelope";
    case "email":
      return "at";
    case "email_subject":
      return "envelope-open";
    case "email_sender":
      return "paper-plane-tilt";
    case "email_recipient":
      return "tray";
    case "ip":
    case "ipv6":
    case "odns_identity":
      return "hard-drives";
    case "network":
      return isUnifiedAsset ? "git-branch" : "hard-drives";
    case "indicator":
      return "fingerprint";
    case "md5":
    case "sha1":
    case "sha256":
      return "file";
    case "name":
    case "file_name":
      return "tag";
    case "file_path":
      return "folder-open";
    case "endpoint":
    case "endpoint.sensor":
    case "amp_computer_guid":
    case "hostname":
      return "desktop";
    case "endpoint.server":
      return "hard-drives";
    case "mac_address":
      return "cpu";
    case "ngfw_id":
      return "wall";
    case "web application":
      return "app-window";
    case "url":
      return "browser";
    case "process.email-service":
      return "arrows-clockwise";
    case "user":
      return "user";
    case "data":
      return "database";
    case "application":
    case "swc-device-id":
      return "cloud";
    case "orbital-node":
    case "orbital_node_id":
      return "asterisk";
    case "observable":
      return "graph";
    case "investigated":
      return "magnifying-glass";
    case "plugin":
      return "puzzle-piece";
    case "process_name":
    case "process":
      return "terminal-window";
    default:
      console.error(`Unknown relations-graph icon type: ${type}`);
      if (type?.includes("-group")) {
        return "circle-wavy";
      } else if (type?.endsWith("_id")) {
        return "circle-wavy";
      } else {
        return "circle";
      }
  }
};
